import TableLogImport from './TableLogImport';

export default TableLogImport;